import { useEventListener } from 'ahooks'

export function useWindowVisibilityChange(callback: (value: DocumentVisibilityState) => void) {
  useEventListener('visibilitychange', callback, { target: document })
  useEventListener('pagehide', callback, { target: document })
  useEventListener('pageshow', callback, { target: document })
}
